// extracted by mini-css-extract-plugin
export default {"asset":"SpotlightAssetWithOverlay_asset__iWlkb"};